module.exports = __webpack_public_path__ + "img/AL.c2b05705.svg";